export const roleTypes = [
    'SUPER_ADMIN',
    'DEVELOPER_ADMIN',
    'APPLICATION_ADMIN',
    'ORGANIZATION_ADMIN',
    'READ_ONLY_ADMIN',
];

export const roleTypeLabel = roleType => ({
    APPLICATION_ADMIN: 'sp-role-type.application-administrator',
    DEVELOPER_ADMIN: 'sp-role-type.developer-administrator',
    END_USER: 'sp-role-type.end-user',
    ORGANIZATION_ADMIN: 'sp-role-type.organization-admin',
    READ_ONLY_ADMIN: 'sp-role-type.read-only-admin',
    SUPER_ADMIN: 'sp-role-type.super-administrator',
})[roleType];

export const roleTypeIconClass = roleType => ({
    APPLICATION_ADMIN: 'fa-list-alt',
    DEVELOPER_ADMIN: 'fa-wrench',
    END_USER: 'fa-user-circle',
    ORGANIZATION_ADMIN: 'fa-sitemap',
    READ_ONLY_ADMIN: 'fa-eye',
    SUPER_ADMIN: 'fa-building',
})[roleType];

export const roleTypeDescription = roleType => ({
    APPLICATION_ADMIN: 'company.roles-help.application-administrator.desc1',
    DEVELOPER_ADMIN: 'company.roles-help.developer-administrator.desc',
    ORGANIZATION_ADMIN: 'company.roles-help.organization-administrator.desc1',
    READ_ONLY_ADMIN: 'company.roles-help.read-only-administrator.desc',
    SUPER_ADMIN: 'company.roles-help.super-administrator.desc',
})[roleType];



// WEBPACK FOOTER //
// ./src/portal/components/sp-role-type/sp-role-type.exports.js